var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "bj-modal",
    {
      attrs: {
        id: "add-inspections-dialog",
        size: "auto",
        title: "Add Inspections from CSV"
      },
      model: {
        value: _vm.addInspectionDialog.visible,
        callback: function($$v) {
          _vm.$set(_vm.addInspectionDialog, "visible", $$v)
        },
        expression: "addInspectionDialog.visible"
      }
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 mb-4" }, [
            _vm._v("\n        Import inspections from CSV file:\n        "),
            _c("input", {
              attrs: {
                type: "file",
                placeholder: "Import inspections from csv file",
                accept: ".csv"
              },
              on: { change: _vm.readCsvFile }
            })
          ]),
          _c("div", { staticClass: "col-12" }, [
            _c("p", [
              _vm._v(
                "\n          Please provide a CSV list in the following structure:\n          "
              ),
              _c("b", [
                _vm._v(
                  "Property address, Business ID, PM email, Unit name,\n            Unit ID, Special notes, Tenant first name, Tenant last name,\n            Tenant phone, Tenant email (',' separated):"
                )
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("q-input", {
                staticClass: "csv-input",
                attrs: { inverted: "", type: "textarea", rows: 4 },
                on: { input: _vm.convertToJson },
                model: {
                  value: _vm.csvString,
                  callback: function($$v) {
                    _vm.csvString = $$v
                  },
                  expression: "csvString"
                }
              }),
              _vm.errors.length
                ? _c(
                    "div",
                    { staticClass: "text-red" },
                    _vm._l(_vm.errors, function(error, index) {
                      return _c("p", { key: "error_" + index }, [
                        _vm._v(
                          "\n            " + _vm._s(error) + "\n          "
                        )
                      ])
                    })
                  )
                : _vm._e(),
              _vm.inspectionsData.length
                ? [
                    _c("p", [_vm._v("Inspections list:")]),
                    _c(
                      "div",
                      { staticClass: "inspections-list-row-wrapper" },
                      _vm._l(_vm.inspectionsData, function(inspection, index) {
                        return _c(
                          "div",
                          { key: "inspection_" + index },
                          [
                            _c(
                              "q-tooltip",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: inspection.error,
                                    expression: "inspection.error"
                                  }
                                ],
                                attrs: {
                                  anchor: "top left",
                                  self: "bottom middle",
                                  offset: [-100, 0]
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(inspection.error) +
                                    "\n              "
                                )
                              ]
                            ),
                            inspection.added === null
                              ? _c("q-icon", {
                                  attrs: { name: "brightness_1", color: "gray" }
                                })
                              : inspection.added === true
                              ? _c("q-icon", {
                                  attrs: {
                                    name: "brightness_1",
                                    color: "green"
                                  }
                                })
                              : inspection.added === false
                              ? _c("q-icon", {
                                  attrs: { name: "error", color: "red" }
                                })
                              : _vm._e(),
                            _c("span", [
                              _vm._v(_vm._s(_vm.getRowTitle(inspection)))
                            ])
                          ],
                          1
                        )
                      })
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
          _c("div", { staticClass: "row justify-content-between" }, [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("q-btn", {
                  attrs: { rounded: "", label: "Cancel", color: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("q-btn", {
                  attrs: {
                    disable: _vm.errors.length !== 0,
                    rounded: "",
                    label: "Add inspections",
                    color: "primary"
                  },
                  on: { click: _vm.addInspections }
                })
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }